export const SUBSIDY_TYPE = 'subsidy';

export default {
  expense: 'Expense Tracking',
  agency: '(Legacy) Subsidy / Agency',
  general: 'General'
};
